import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import { RiArrowGoBackLine } from 'react-icons/ri';
import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import JoditEditor from "jodit-react";
import moment from "moment";
import { MdCloudUpload, MdPlaylistAdd, MdRefresh, MdWorkHistory } from "react-icons/md";
import Request from "../../Request";
import { API_URL, STORAGE_URL } from "../../variables";
import Attention from "../ReusableComponents/Attention";
import ProcessoConfigFields from "./ProcessoConfigFields";
import "./label.css";

const initialConfig = () => ({
    regras: "",
    inicio: moment(),
    hora_inicio: moment(),
    fim: moment().add(1, "day"),
    hora_fim: moment().add(1, "hour"),
    restrict_access: false,
    inicio_access: moment().subtract(24, "hours"),
    hora_inicio_access: moment().subtract(24, "hours"),
    fim_access: moment(),
    hora_fim_access: moment(),
    online: true,
    is_interview: false,
    simulado: false,
    fiscalizacao: "all",
    type_time: "all",
    tempo_prova: "",
    full_screen: true,
    screen_sharing: false,
    screen_extended_retrict: true,
    required_camera_external: false,
    mobile: false,
    exam_per_time: false,
    face_validation: false,
    face_validation_periodicaly: false,
    time_validation_periodicaly: 40,
    chat_type: "all",
    chat_time: 60,
    request_time: 60,
    show_rascunho: true,
    need_pause: false,
    has_blocks: false,
});

const field = (label, children, description = null, required = true) => (
    <div className="flex fdcolumn flex1 margin-bottom processo-lote-field">
        <Form.Label>{label} {required && <Attention />}</Form.Label>
        {description && <small className="text-muted mb-2">{description}</small>}
        {children}
    </div>
);

const statusLabel = (status) => {
    if (status === "Finalizado") return "Finalizado";
    if (status === "Erro na execução") return "Erro";
    if (status === "Executando") return "Executando";
    return status || "Pendente";
};

const ModalProcessosLote = ({ showModal, setShowModal, faculdadeId, onFinish, changeText, empresa }) => {
    const [step, setStep] = useState("names");
    const [names, setNames] = useState([]);
    const [nameDraft, setNameDraft] = useState("");
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingValue, setEditingValue] = useState("");
    const [config, setConfig] = useState(initialConfig());
    const [jobs, setJobs] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });
    const [loadingJobs, setLoadingJobs] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);
    const [msgErro, setMsgErro] = useState("");
    const [fileValue, setFileValue] = useState("");
    const intervalRef = useRef(null);

    const entity = changeText ? "vaga/cargo" : "processo";
    const entityPlural = changeText ? "vagas/cargos" : "processos";

    const editorConfig = useMemo(() => ({
        height: 260,
        readonly: loadingImage,
        language: "pt_br",
        toolbarButtonSize: "large",
        buttons: "source,bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,center,right,justify,font,fontsize,paragraph,classSpan,image,brush,,undo,redo,hr,link,symbol,table",
        uploader: {
            url: API_URL + "faculdade/upload_image",
            insertImageAsBase64URI: false,
            imagesExtensions: ["jpg", "png", "jpeg", "gif"],
            headers: { accept: "application/json", Authorization: "Bearer " + localStorage.getItem("token") },
            filesVariableName: () => "imagem",
            withCredentials: false,
            pathVariableName: "path",
            method: "POST",
            prepareData: (formdata) => {
                setLoadingImage(true);
                return formdata;
            },
            process: (resp) => {
                setLoadingImage(false);
                return { files: [STORAGE_URL + resp.imagem] };
            },
            error: () => setLoadingImage(false),
            defaultHandlerSuccess: function (resp) {
                if (resp.files && resp.files.length) {
                    resp.files.forEach((filename) => this.selection.insertImage(filename));
                }
            },
            defaultHandlerError: () => setLoadingImage(false),
        },
    }), [loadingImage]);

    useEffect(() => {
        if (showModal) {
            getJobs();
            intervalRef.current = setInterval(() => getJobs(pagination.current_page), 60000);
        }
        return () => clearInterval(intervalRef.current);
    }, [showModal]);

    const updateConfig = (key, value) => setConfig((current) => ({ ...current, [key]: value }));
    const updateConfigState = (nextConfig) => setConfig(nextConfig);

    const addNamesFromText = (text) => {
        const items = String(text || "").split(/[,\n\r;]/).map((item) => item.trim()).filter(Boolean);
        if (items.length === 0) return;
        setNames((current) => {
            const normalized = current.map((item) => item.toLowerCase());
            const next = [...current];
            items.forEach((item) => {
                if (!normalized.includes(item.toLowerCase())) {
                    normalized.push(item.toLowerCase());
                    next.push(item);
                }
            });
            return next;
        });
    };

    const commitDraft = () => {
        addNamesFromText(nameDraft);
        setNameDraft("");
    };

    const readFile = (file) => {
        setMsgErro("");
        const reader = new FileReader();
        reader.onload = () => {
            const rows = String(reader.result || "")
                .split(/\r?\n/)
                .map((line) => line.split(/[;\t,]/)[0].trim())
                .filter(Boolean);
            addNamesFromText(rows.join(","));
        };
        reader.onerror = () => setMsgErro("Não foi possível ler o arquivo enviado.");
        reader.readAsText(file);
    };

    const getJobs = async (page = 1) => {
        setLoadingJobs(true);
        const response = await Request.Get(`faculdade/get_processos_lote_jobs/${faculdadeId}?page=${page}`);
        if (response && response.pagination && response.pagination.current_page == page) {
            setJobs(response.data || []);
            setPagination(response.pagination);
        }
        setLoadingJobs(false);
    };

    const buildPayload = () => {
        const online = empresa?.online_proccess === false ? false : config.online;
        const fiscalizacao = config.simulado ? (config.fiscalizacao === "all" ? "all" : "none") : config.fiscalizacao;
        return {
            names,
            regras: empresa?.online_proccess === false ? "---" : config.regras,
            faculdade_id: faculdadeId,
            inicio: moment(config.inicio).format("DD/MM/YYYY"),
            fim: moment(config.fim).format("DD/MM/YYYY"),
            hora_inicio: moment(config.hora_inicio).format("HH:mm"),
            hora_fim: moment(config.hora_fim).format("HH:mm"),
            inicio_access: moment(config.inicio_access).format("DD/MM/YYYY"),
            fim_access: moment(config.fim_access).format("DD/MM/YYYY"),
            hora_inicio_access: moment(config.hora_inicio_access).format("HH:mm"),
            hora_fim_access: moment(config.hora_fim_access).format("HH:mm"),
            restrict_access: config.restrict_access,
            is_interview: config.is_interview,
            online,
            need_pause: config.simulado ? false : config.need_pause,
            fiscalizacao,
            chat_type: config.chat_type,
            show_fiscal_chat: config.show_fiscal_chat !== false,
            show_rascunho: config.show_rascunho,
            simulado: config.simulado,
            type_time: config.simulado ? "restrict" : config.type_time,
            tempo_prova: config.simulado ? 4 : config.tempo_prova,
            chat_time: config.chat_time * 60,
            request_time: config.request_time * 60,
            time_validation_periodicaly: config.time_validation_periodicaly,
            full_screen: config.full_screen,
            screen_extended_retrict: config.screen_sharing == true ? true : config.screen_extended_retrict,
            screen_sharing: config.screen_sharing,
            required_camera_external: fiscalizacao == "all" && config.mobile == false ? config.required_camera_external : false,
            mobile: config.mobile,
            exam_per_time: config.exam_per_time,
            face_validation: config.face_validation,
            allow_face_validation_skip: config.allow_face_validation_skip === true,
            face_validation_periodicaly: config.face_validation_periodicaly,
        };
    };

    const save = async () => {
        setMsgErro("");
        if (names.length === 0) {
            setStep("names");
            setMsgErro(`Informe pelo menos um nome de ${entity}.`);
            return;
        }
        if (empresa?.online_proccess !== false && !config.regras) {
            setMsgErro("Preencha as regras antes de salvar.");
            return;
        }
        setLoadingSave(true);
        const response = await Request.Post("faculdade/store_processos_lote", JSON.stringify(buildPayload()), { "Content-Type": "application/json" });
        setLoadingSave(false);
        if (response === undefined) {
            setMsgErro("Erro ao conectar com o servidor.");
            return;
        }
        if (response.errors || response.error) {
            setMsgErro(Object.values(response.errors || { error: response.error }).join("\n"));
            return;
        }
        setNames([]);
        setNameDraft("");
        setConfig(initialConfig());
        setStep("names");
        getJobs();
        onFinish();
    };

    const close = () => {
        clearInterval(intervalRef.current);
        setShowModal(false);
        setMsgErro("");
        setStep("names");
    };

    const goToConfig = () => {
        commitDraft();
        if (names.length === 0 && nameDraft.trim() === "") {
            setMsgErro(`Informe pelo menos um nome de ${entity}.`);
            return;
        }
        setMsgErro("");
        setStep("config");
    };

    return (
        <Modal show={showModal} centered dialogClassName="modal-90w modal-width processo-lote-modal" onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Adicionar {entityPlural} em lote</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {msgErro && <div className="alert alert-danger" style={{ whiteSpace: "pre-wrap" }}>{msgErro}</div>}

                <div className="processo-lote-stepper">
                    <button type="button" className={step === "names" ? "active" : ""} onClick={() => setStep("names")}>1. Nomes e execuções</button>
                    <button type="button" className={step === "config" ? "active" : ""} disabled={names.length === 0 && nameDraft.trim() === ""} onClick={goToConfig}>2. Configurações</button>
                </div>

                {step === "names" && <>
                    <section className="processo-lote-panel">
                        <div className="processo-lote-panel-title">
                            <h5><MdWorkHistory /> Execuções de criação em lote</h5>
                            <Button variant="outline-primary" size="sm" onClick={() => getJobs(pagination.current_page)}><MdRefresh /> Atualizar</Button>
                        </div>
                        <div className="table-responsive">
                            <ResponsiveTable className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Erro</th>
                                        <th>Progresso</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!loadingJobs && jobs.length === 0 && <tr><td colSpan="4" className="text-center text-muted py-4">Nenhuma execução encontrada.</td></tr>}
                                    {!loadingJobs && jobs.map((job) => (
                                        <tr key={job.id}>
                                            <td><span className={`badge ${job.status === "Finalizado" ? "badge-success" : job.status === "Erro na execução" ? "badge-danger" : "badge-warning"}`}>{statusLabel(job.status)}</span></td>
                                            <td style={{ whiteSpace: "pre-wrap" }}>{job.error_friendly || "-"}</td>
                                            <td>{job.progresso || 0}</td>
                                            <td>{job.total_progresso || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </ResponsiveTable>
                            {loadingJobs && <div className="d-flex justify-content-center my-3"><CircularProgress /></div>}
                        </div>
                    </section>

                    <section className="processo-lote-panel">
                        <h5><MdPlaylistAdd /> Nomes dos {entityPlural}</h5>
                        <small className="text-muted">Digite os nomes e separe por vírgula. Cada nome será criado com a configuração definida na próxima etapa.</small>
                        <div className="processo-token-field">
                            {names.map((name, index) => editingIndex === index ? (
                                <input
                                    key={`edit-${index}`}
                                    autoFocus
                                    className="processo-token-input editing"
                                    value={editingValue}
                                    onChange={(e) => setEditingValue(e.target.value)}
                                    onBlur={() => {
                                        const value = editingValue.trim();
                                        setNames((current) => value ? current.map((item, itemIndex) => itemIndex === index ? value : item) : current.filter((_, itemIndex) => itemIndex !== index));
                                        setEditingIndex(null);
                                    }}
                                />
                            ) : (
                                <span className="processo-token" key={`${name}-${index}`}>
                                    <button type="button" onClick={() => { setEditingIndex(index); setEditingValue(name); }}>{name}</button>
                                    <button type="button" onClick={() => setNames((current) => current.filter((_, itemIndex) => itemIndex !== index))}>×</button>
                                </span>
                            ))}
                            <input
                                className="processo-token-input"
                                value={nameDraft}
                                placeholder={`Nome do ${entity}`}
                                onChange={(e) => {
                                    if (/[,\n\r;]/.test(e.target.value)) {
                                        addNamesFromText(e.target.value);
                                        setNameDraft("");
                                    } else {
                                        setNameDraft(e.target.value);
                                    }
                                }}
                                onBlur={commitDraft}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === ",") {
                                        e.preventDefault();
                                        commitDraft();
                                    }
                                }}
                                onPaste={(e) => {
                                    const pasted = e.clipboardData.getData("text");
                                    if (/[,\n\r;]/.test(pasted)) {
                                        e.preventDefault();
                                        addNamesFromText(pasted);
                                    }
                                }}
                            />
                        </div>
                        <div className="mt-3">
                            <Form.Label>Subir lista por arquivo</Form.Label>
                            <div className="processo-file-upload">
                                <input id="processos-lote-file" type="file" accept=".csv,.txt" value={fileValue} onChange={(e) => {
                                    const file = e.target.files[0];
                                    setFileValue("");
                                    if (file) readFile(file);
                                }} />
                                <label htmlFor="processos-lote-file"><MdCloudUpload /> Selecionar arquivo CSV/TXT</label>
                                <span>Use a primeira coluna para os nomes.</span>
                            </div>
                        </div>
                    </section>
                </>}

                {step === "config" && <Form className="processo-lote-config">
                    <h5>Configurações dos {entityPlural}</h5>
                    {empresa?.online_proccess !== false && <InputGroup>{field(`Regras do ${entity}`, <>
                        {loadingImage && <Spinner animation="border" size="sm" className="mb-2" />}
                        <JoditEditor value={config.regras} config={editorConfig} tabIndex={1} onBlur={(content) => updateConfig("regras", content)} />
                    </>)}</InputGroup>}

                    <ProcessoConfigFields
                        state={config}
                        setState={updateConfigState}
                        empresa={empresa}
                        restrictAccessFields={(
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <InputGroup>
                                    {field("Data inicial do intervalo", <DatePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Data inválida" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" format="DD/MM/YYYY" value={config.inicio_access} onChange={(date) => updateConfig("inicio_access", date)} />)}
                                    {field("Horário inicial do intervalo", <TimePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Horário inválido" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" label="" value={config.hora_inicio_access} onChange={(date) => updateConfig("hora_inicio_access", date)} />)}
                                </InputGroup>
                                <InputGroup>
                                    {field("Data de encerramento do intervalo", <DatePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Data inválida" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" format="DD/MM/YYYY" value={config.fim_access} onChange={(date) => updateConfig("fim_access", date)} />)}
                                    {field("Horário de encerramento do intervalo", <TimePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Horário inválido" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" label="" value={config.hora_fim_access} onChange={(date) => updateConfig("hora_fim_access", date)} />)}
                                </InputGroup>
                            </MuiPickersUtilsProvider>
                        )}
                    >
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <InputGroup>
                                {field("Data de início", <DatePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Data inválida" ampm={false} minDate={moment()} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" format="DD/MM/YYYY" value={config.inicio} onChange={(date) => updateConfig("inicio", date)} />)}
                                {field("Horário de início", <TimePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Horário inválido" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" label="" value={config.hora_inicio} onChange={(date) => updateConfig("hora_inicio", date)} />)}
                            </InputGroup>
                            <InputGroup>
                                {field("Data de encerramento", <DatePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Data inválida" ampm={false} minDate={moment()} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" format="DD/MM/YYYY" value={config.fim} onChange={(date) => updateConfig("fim", date)} />)}
                                {field("Horário de encerramento", <TimePicker autoOk margin="normal" style={{ width: "100%" }} invalidDateMessage="Horário inválido" ampm={false} id="time-picker" cancelLabel="Cancelar" clearLabel="Limpar" label="" value={config.hora_fim} onChange={(date) => updateConfig("hora_fim", date)} />)}
                            </InputGroup>
                        </MuiPickersUtilsProvider>
                    </ProcessoConfigFields>
                </Form>}
            </Modal.Body>
            <Modal.Footer>
                {step === "config" && <Button variant="secondary" onClick={() => setStep("names")} className="app-back-button"><RiArrowGoBackLine aria-hidden="true" /> Voltar</Button>}
                {step === "names" && <Button variant="primary" onClick={goToConfig} disabled={names.length === 0 && nameDraft.trim() === ""}>Próximo</Button>}
                {step === "config" && <Button variant="success" onClick={save} disabled={loadingSave}>{loadingSave ? <Spinner animation="border" size="sm" /> : `Criar ${entityPlural}`}</Button>}
                <Button variant="light" onClick={close}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalProcessosLote;
